export default "__VITE_ASSET__CpklFayB__"